import './App.css';
import { useState } from 'react';

function App() {

  const [lamellesPos, setLamellesPos] = useState([0, 0, 0]);
  const [formDatas, setFormDatas] = useState({value: 'none'});
  const [uri, setUri] = useState(null);
  const [status, setStatus] = useState(false);

  const [possibilites, setPossibilites] = useState([13260, 13360, 13460]);
  const val = randomInt(0, 2);

  const animationLoose = () => {
    let newPos = [...lamellesPos];
    newPos[0] = possibilites[val];
    newPos[1] = possibilites[(val === 2) ? 0 : val + 1];
    newPos[2] = possibilites[(val === 0) ? 2 : val - 1];
    setLamellesPos(newPos);
  }

  // 1300;
  // ??1260?
  const animationSac = () => {
    let newPos = [...lamellesPos];
    newPos[0] = 13260; 
    newPos[1] = 13260;
    newPos[2] = 13260;
    setLamellesPos(newPos);
  }

  const animationKeygen = () => {
    let newPos = [...lamellesPos];
    newPos[0] = 13360;
    newPos[1] = 13360;
    newPos[2] = 13360;
    setLamellesPos(newPos);
  }

  const send = async () => {
    const formData = new FormData();
    formData.append("input[game_id]", "fbd89165-a22b-4a2f-a988-aa7eaabec7dd");
    formData.append("input[lang]", "en");
  
    // Ajouter les données dynamiques (formDatas est supposé être un objet)
    for (let key in formDatas) {
      formData.append(`input[player_data][${key}]`, formDatas[key]);
    }
  
    try {
      let response = await fetch("https://api-gain.web-treeosk.online/play", {
        method: "POST",
        body: formData, // On envoie directement FormData
      });
  
      let responseData = await response.json(); // Récupérer la réponse en JSON
      console.log(responseData);
  
      // Vérifier si gain_id existe avant d'accéder à ses données
      if (responseData.data && responseData.data.id) {
        switch (responseData.data.id) {
          case "af63afaa-046b-426e-a1b1-055f6b881a4a":
            animationKeygen();
            break;
          case '90acb257-b5ca-437a-9f2b-b4f9e5d7964e':
            animationSac();
            break;
          case '9838dda8-b925-44f6-a343-40e465c4fe56':
            animationLoose();
            break;
          default:
            break;  
        }
        setTimeout(() => {
          setUri(responseData.data.uri);
        }, 10000);
      }
    } catch (error) {
      console.error("Erreur lors de la requête :", error);
    }
  };

  const start = () => {
    setStatus(true);
    const audio = new Audio('./assets/son.mp3');
    audio.play();
    setTimeout(() => {
      send();
    }, 500);
  };

  return (
    <div className="App">
      <div style={{position: 'fixed', zIndex: 500, background: 'url(./assets/box.png)', width: '80%', left: '10%', height: '80%', top: '10%', backgroundSize: 'cover'}}>
      </div>
      <div style={{position: 'fixed', zIndex: 100, width: '58%', background: 'white', height: '36%', left: '20%', top: '35%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row', gap: '4%'}}>
        <div style={{flex: 1, background: 'url(./assets/lamelle.jpg)', width: '100%', height: '100%', backgroundSize: '100%', backgroundPositionY: `${lamellesPos[0]}%`, transitionDuration: '7s'}}>

        </div>
        <div style={{flex: 1, background: 'url(./assets/lamelle.jpg)', width: '100%', height: '100%', backgroundSize: '100%', backgroundPositionY: `${lamellesPos[1]}%`, transitionDuration: '8s'}}>

        </div>
        <div style={{flex: 1, background: 'url(./assets/lamelle.jpg)', width: '100%', height: '100%', backgroundSize: '100%', backgroundPositionY: `${lamellesPos[2]}%`, transitionDuration: '9s'}}>

        </div>
      </div>
      {
        uri && <img src={uri} alt='gain' style={{position: 'fixed', zIndex: 4000, height: '50%', width: '50%', left: '25%', top: '25%'}}/>
      }
      {
        !status &&
        <button onClick={start} style={{position: 'fixed', zIndex: 5000, fontSize: '2vw', top: '50%', left: '40%', width: '20%', border: 'solid 0.4em #FFD0E0', borderRadius: '1em', background: 'pink', padding: '1em', fontWeight: 'bold', color: '#FB008C'}}>
          CLICK HERE TO PLAY
        </button>
      }
    </div>
  );
}

const randomInt = (min, max) => {
  return Math.floor(Math.random() * (max - min) + min);
}

export default App;
